/* eslint-disable import/no-anonymous-default-export */
import { Form, Input, Table } from "antd";
import { FilterValue } from "antd/lib/table/interface";
import { useEffect } from "react";
import DataFilter from "../../common/components/DataFilter";
import DataTable from "../../common/components/DataTable";
import EditableCell from "../../common/components/EditableCell";
import MainLayout from "../../common/components/MainLayout";
import useUsuariosAPI, { Usuario, UsuarioSave } from "../useUsuariosAPI";


export default () => {
    const api = useUsuariosAPI();
    const createPage = "/usuarios/guardar"
    const editPage = "/usuarios/guardar/{Id}"

    const [nombreFilterForm] = Form.useForm();
    const [apellidoFilterForm] = Form.useForm();
    const [nombreUsuarioFilterForm] = Form.useForm();

    const generateFilters = (filters:Record<string, FilterValue | null>) => {

        return [
            filters?.Nombre != null ?  `contains(Nombre,'${filters!.Nombre![0]}')` : "",
            filters?.Apellido != null ?  `contains(Apellido,'${filters!.Apellido![0]}')` : "",
            filters?.NombreUsuario != null ?  `contains(NombreUsuario,'${filters!.NombreUsuario![0]}')` : "",
            
        ];
    }


    useEffect(()=>{

    },[]);

    return (
        <MainLayout >
            <DataTable<Usuario,UsuarioSave>
            list={()=>api.list({$expand:["Role"]})}
            delete={api.delete}
            createAction={{
                label:"Agregar usuario",
                path:createPage
            }}
            deleteMultipleAction
            defaultSortOrder={"Apellido desc"}
            selectionType='checkbox'
            title={"Usuarios"}
            generateFilters={generateFilters}
            editItemAction={editPage}
            deleteItemAction
            deleteItemActionConfirmMessage={(item) => `¿Eliminar a ${item.Apellido} ${item.Nombre}?`}
            defaultPageSize={25}
            
            >


                <Table.Column<Usuario>
                    width={`25%`}
                    title="Apellido"
                    dataIndex={"Apellido"}
                    sorter
                    render={(val, record)=>{                        
                        return <EditableCell<Partial<Usuario>>
                            save={api.save}
                            id={record.Id}
                            render={(value)=>value.Apellido!}
                            formValue={{Apellido:val}}
                            formItem={<Form.Item style={{marginBottom:0}} name={"Apellido"} ><Input maxLength={150} /></Form.Item>}
                            value={record} />
                    }
                    }
                    defaultSortOrder={'descend'}
                    sortDirections={["ascend","descend","ascend"]}
                    filterDropdown={(props)=>{
                        return (
                            <DataFilter filterDropdownProps={props} form={nombreFilterForm} >
                                <Form.Item name={"Apellido"} style={{marginBottom:10}}>
                                    <Input placeholder='Apellido...'></Input>
                                </Form.Item>
                            </DataFilter>
                        );
                    }
                   }
                   
                />

                <Table.Column<Usuario>
                    width={`25%`}
                    title="Nombre"
                    dataIndex={"Nombre"}
                    sorter
                    render={(val, record)=>
                        <EditableCell<Partial<Usuario>>
                            save={api.save}
                            id={record.Id}
                            render={(value)=>value.Nombre!}
                            formValue={{Nombre:val}}
                            formItem={<Form.Item style={{marginBottom:0}} name={"Nombre"} ><Input maxLength={150} /></Form.Item>}
                            value={record} />
                    }
                    sortDirections={["ascend","descend","ascend"]}
                    filterDropdown={(props)=>{
                        return (
                            <DataFilter filterDropdownProps={props} form={apellidoFilterForm} >
                                <Form.Item name={"Nombre"} style={{marginBottom:10}}>
                                    <Input placeholder='Nombre...'></Input>
                                </Form.Item>
                            </DataFilter>
                        );
                    }
                   }
                   
                />

                <Table.Column<Usuario>
                    width={`13%`}
                    title="Nombre de usuario"
                    dataIndex={"NombreUsuario"}
                    sorter
                    render={(val, record)=>
                        <EditableCell<Partial<Usuario>>
                            save={api.save}
                            id={record.Id}
                            render={(value)=>value.NombreUsuario!}
                            formValue={{NombreUsuario:val}}
                            formItem={<Form.Item style={{marginBottom:0}} name={"NombreUsuario"} ><Input maxLength={150} /></Form.Item>}
                            value={record} />
                    }
                    sortDirections={["ascend","descend","ascend"]}
                    filterDropdown={(props)=>{
                        return (
                            <DataFilter filterDropdownProps={props} form={nombreUsuarioFilterForm} >
                                <Form.Item name={"NombreUsuario"} style={{marginBottom:10}}>
                                    <Input placeholder='Nombre de usuario...'></Input>
                                </Form.Item>
                            </DataFilter>
                        );
                    }
                   }
                   
                />

                <Table.Column<Usuario>
                    width={`12%`}
                    title="Rol"
                    dataIndex={"Role"}
                    sorter
                    render={(val, record)=>val.Nombre}
                    sortDirections={["ascend","descend","ascend"]}
                   
                />



            </DataTable>
        </MainLayout>
    );

};